import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace',
  standalone: true,
})
export class ReplacePipe implements PipeTransform {
  transform(input: any, pattern: any, replacement: any): any {
    if (!(typeof input === 'string') || typeof pattern === 'undefined' || typeof replacement === 'undefined') {
      return input;
    }
    return input.replace(pattern, replacement);
  }
}
